import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table as AntTable } from 'antd';
import { Colors } from '@common/tokens';

export function Table({
  loading,
  columns,
  dataSource,
  pagination,
  onRow,
  onChange,
  locale,
  rowKey,
}) {
  const [pageNumber, setPageNumber] = useState(pagination.current || 1);

  pagination.showSizeChanger = true;
  pagination.current = pageNumber;
  pagination.onChange = (selectedPageNumber) => {
    setPageNumber(selectedPageNumber);
  };
  pagination.onShowSizeChange = () => {
    setPageNumber(1);
  };

  const onDefaultChange = (pagination, filters, sorter) => {
    if (onChange) onChange(pagination, filters, sorter); // Triggers data fetching
  };

  return (
    <section className="Table">
      <AntTable
        rowKey={rowKey}
        loading={loading}
        columns={columns}
        dataSource={dataSource}
        rowClassName={(record) => `data-row ${record.rowClassName}`}
        onRow={onRow}
        locale={locale}
        scroll={{ x: 1280 }}
        pagination={pagination}
        onChange={onDefaultChange}
      />
      <style jsx>
        {`
          .Table :global(.ant-table-tbody > tr.disabled-row:hover > td) {
            background: ${Colors.steelLightest};
          }
          .Table :global(.disabled-row td) {
            background: ${Colors.steelLightest};
          }
          :global(.ant-table-filter-dropdown .ant-dropdown-menu-item-selected) {
            background-color: white;
          }
          :global(.ant-dropdown-menu-item) {
            display: flex;
          }
        `}
      </style>
    </section>
  );
}

Table.propTypes = {
  columns: PropTypes.array,
  dataSource: PropTypes.array,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    staffingRequestId: PropTypes.string,
    onChange: PropTypes.func,
    onShowSizeChange: PropTypes.func,
    defaultPageSize: PropTypes.number,
    total: PropTypes.number,
    showSizeChanger: PropTypes.bool,
  }),
  locale: PropTypes.object,
  onRow: PropTypes.func,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

Table.defaultProps = {
  rowKey: 'key',
};
